import { Directive } from '@angular/core';

@Directive({
  selector: '[appDummyContainer]'
})
export class DummyContainerDirective {}
